import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
  name: 'convertUtc',
  standalone: true
})
export class ConvertUtcPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
 
    // Parse the UTC datetime string
    const utcDate = new Date(value);
 
    // Get the timezone offset in minutes
    const timezoneOffset = new Date().getTimezoneOffset();
 
    // Adjust the UTC date by the timezone offset
    utcDate.setMinutes(utcDate.getMinutes() - timezoneOffset);
 
    // Define options for local date formatting
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',  // 'short' gives the three-letter abbreviation (e.g., "Jan")
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // Use 12-hour format (AM/PM)
    };
 
    // Format the date into a string like "28-Jan-2025 11:43:56 AM"
    const formattedDate = utcDate.toLocaleString('en-GB', options).replace(',', '');
 
    return formattedDate;
  }
}